import SwiperSlider from '../base';

const selectors = {
  gradientEl: '[data-slider-gradient]',
  sliderEl: '[data-comp-general-slider]',
  nextEl: '[data-navigation-next-el]',
  prevEl: '[data-navigation-prev-el]',
  paginationEl: '[data-pagination-el]',
};

const swiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  speed: 600,
  preventClicks: false,
  preventClicksPropagation: false,
  navigation: {
    nextEl: selectors.nextEl,
    prevEl: selectors.prevEl,
  },
  pagination: {
    el: selectors.paginationEl,
    clickable: true,
  },
  breakpoints: {
    // when window width is >= 768px
    768: {
      allowTouchMove: false,
    },
  },
};

export default class SectionGeneralSlider extends SwiperSlider {
  static selector = selectors.sliderEl;
  constructor(containerEl) {
    super(containerEl);
    this.generalSlider = new this.Swiper(
      this.$container,
      swiperOptions,
    );
    this.nextEl = this.$container.querySelector(selectors.nextEl);
    this.prevEl = this.$container.querySelector(selectors.prevEl);
    this.initEvents();
    triggerWindowResize(); // Trigger window resize after timeout to correct visual errors in case that JS loaded before CSS
  }

  initEvents() {
    this.addSlideChangeListener();
    this.gradientEvents();
  }

  addSlideChangeListener() {
    this.generalSlider.on('slideChange', () => {
      window.dispatchEvent(new Event('resize'));
    });
  }

  gradientEvents() {
    const parentContainer = this.$container.parentNode.parentNode;
    const gradient = parentContainer.querySelector(selectors.gradientEl);
    this.generalSlider.on('reachEnd', () => {
      if (gradient) {
        gradient.classList.add('vehicles-callout-slider__gradient--fade-out');
      }
    });

    this.generalSlider.on('fromEdge', () => {
      if (gradient) {
        gradient.classList.remove('vehicles-callout-slider__gradient--fade-out');
      }
    });
  }
}

function triggerWindowResize() {
  window.setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
}
